import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="pulse-header">
      <div className="pulse-container">
        <nav className="pulse-nav">
          <a href="/" className="pulse-logo">
            <div className="pulse-logo-icon">
              <span className="pulse-logo-letter">P</span>
            </div>
            <span className="pulse-logo-text">PulseChat</span>
          </a>
          <div className="pulse-nav-links">
            <a href="/chat.php" className="pulse-nav-link">AI Chat</a>
            <a href="/#creative" className="pulse-nav-link">Creative Suite</a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;